import { render, staticRenderFns } from "./share.vue?vue&type=template&id=9b8fc4c4&"
import script from "./share.js?vue&type=script&lang=js&"
export * from "./share.js?vue&type=script&lang=js&"
import style0 from "./share.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports